import { apiCall, ApiConfig } from '../../../config/api'
import { useConfirmsAction } from '../../../hooks/useConfirmAction'
import { Filter, Position } from '../../../interfaces'
import {
  ICreatePosition,
  PositionGrid
} from '../../../interfaces/Position/Position'
import { usePosition } from '../context'
import { busquedaInitialState } from '../reducer/positionReducer'
import positionActions from './positionActions'
import { crudActions } from '../types/positionConfig'
import { SortField } from '../../../interfaces/DataGrid/DataGridSettings'

/*
Copyright 2022-08-24 por miguel balloqui Ecomsur Holding S.A ©
Detalle: Se agrega positionBusiness
*/
const positionBusiness = () => {
  const { setLoadingConfirm } = useConfirmsAction()
  const {
    setBusqueda,
    setFilters,
    switchSnackBar,
    switchEditableItem,
    switchModal,
    setIdForDelete,
    switchModalDelete,
    setMessageColor,
    setMessageStatus,
    switchModalView,
    switchModalRedireccion,
    setRedirect,
    setPosiciones,
    setLoaderName,
    setChangePage,
    setChangePageSize,
    setSorters,
    setIsLoading,
    setItemsQuantity,
    setRows,
    setTotalItems,
    switchModalPositionMassive,
    setEditModePositionMassive,
    setLoadingExport
  } = positionActions()

  const { dispatch, state } = usePosition()

  const { busqueda, idForDelete, page, rowsPerPage, filters, sorters } = state
  const { canRedirect } = crudActions

  const fetchDataGrid = () => {
    const uri: string = `${ApiConfig.PositionApi}?pageIndex=${page}&pageSize=${rowsPerPage}`
    const arrFilters: string[] = filters.map(
      ({ key, value }) => `${key}=${value}`
    )

    const arrSorters: string[] = sorters
      ? sorters.map((sorter) => `sorters=${JSON.stringify(sorter)}`)
      : []
    const strFilters: string =
      arrFilters.length > 0 ? `&${arrFilters.join('&')}` : ''
    const strSorters: string =
      arrSorters.length > 0 ? `&${arrSorters.join('&')}` : ''

    const finalUri: string = uri + strFilters + strSorters

    dispatch(setIsLoading(true))
    apiCall('GET', finalUri)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`No fue posible obtener los registros.`)
        }
        return response.data
      })
      .then(({ items, totalItems }) => {
        if (items.length === 0) {
          dispatch(setChangePage(0))
          dispatch(setItemsQuantity(-1))
        } else {
          dispatch(setItemsQuantity(1))
        }
        dispatch(setRows(items))
        dispatch(setTotalItems(totalItems))
        dispatch(setIsLoading(false))
      })
      .catch(({ data: { message } }) => {
        MostrarMensajeConfirmacion(message, 'error')
        dispatch(setIsLoading(false))
        dispatch(setChangePage(0))
      })
  }

  const fetchExportData = () => {
    const uri: string = `${ApiConfig.ProcessApi}/PositionMassiveExport?`
    const arrFilters: string[] = filters.map(
      ({ key, value }) => `${key}=${value}`
    )
    const arrSorters: string[] = sorters
      ? sorters.map((sorter) => `sorters=${JSON.stringify(sorter)}`)
      : []
    const strFilters: string =
      arrFilters.length > 0 ? `&${arrFilters.join('&')}` : ''
    const strSorters: string =
      arrSorters.length > 0 ? `&${arrSorters.join('&')}` : ''

    const finalUri: string = uri + strFilters + strSorters

    dispatch(setLoadingExport(true))

    apiCall('GET', finalUri)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`No fue posible agendar proceso.`)
        }
        return response.data
      })
      .then(() => {
        MostrarMensajeConfirmacion('proceso exportación agendado', 'success')
      })
      .catch(({ data: { message } }) => {
        MostrarMensajeConfirmacion(message, 'error')
      })
      .finally(() => dispatch(setLoadingExport(false)))
  }

  // Setea en el reducer el valor de los fltros de busqueda
  const handleBusqueda = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.name === 'positionName') {
      handleChangeAutoCompleter(event)
    }

    dispatch(
      setBusqueda({ ...busqueda, [event.target.name]: event.target.value })
    )
  }

  const handleChangePage = (_event: unknown, newPage: number) => {
    dispatch(setChangePage(newPage))
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    dispatch(setChangePageSize(parseInt(event.target.value, 10)))
    dispatch(setChangePage(0))
  }

  const handleOnSortChanged = (sorters: SortField[]) => {
    dispatch(setSorters(sorters))
  }

  const handleSubmit = async (values: any | Position) => {
    apiCall('POST', ApiConfig.PositionApi, values)
      .then((response) => {
        switch (response.status) {
          case 201: {
            return response.data
          }
          case 409: {
            throw new Error(
              `Ya existe un registro con código de posición ${values.positionCode} o con nombre de posición ${values.positionName}.`
            )
          }
          default: {
            throw new Error('Hubo un problema al crear la Posición.')
          }
        }
      })
      .then(() => {
        MostrarMensajeConfirmacion('Posición creada correctamente.', 'success')
        hadleOpenRedireccion()
        fetchFilteredData()
      })
      .catch(({ data: { message } }) => {
        MostrarMensajeConfirmacion(message.toString(), 'error')
      })
  }

  const handleSubmitEdit = async (values: any | ICreatePosition) => {
    apiCall('PUT', `${ApiConfig.PositionApi}/${values.id}`, values)
      .then((response) => {
        switch (response.status) {
          case 204: {
            break
          }
          case 409: {
            throw new Error(
              `Ya existe un registro con código de posición ${values.positionCode} o con nombre de posición ${values.positionName}.`
            )
          }
          default: {
            throw new Error('Hubo un problema al actualizar la Posición.')
          }
        }
      })
      .then(() => {
        MostrarMensajeConfirmacion(
          'Posición actualizado correctamente.',
          'success'
        )
        fetchFilteredData()
      })
      .catch(({ data: { message } }) => {
        MostrarMensajeConfirmacion(message.toString(), 'error')
      })
  }

  const MostrarMensajeConfirmacion = (mensaje: string, tipoMensaje: any) => {
    dispatch(setMessageStatus(mensaje))
    dispatch(setMessageColor(tipoMensaje))
    dispatch(switchSnackBar(true))
    dispatch(switchModal(false))
  }

  const fetchFilteredData = () => {
    dispatch(
      setFilters(
        busqueda
          ? Object.keys(busqueda)
              .filter((key) => busqueda[key] !== '')
              .map<Filter>((key) => ({
                key: key,
                value: busqueda[key].toString()
              }))
          : []
      )
    )
  }

  const resetearBusqueda = () => {
    dispatch(setBusqueda(busquedaInitialState))
  }

  const handleSnackbar = (isOpen: boolean) => {
    dispatch(switchSnackBar(isOpen))
  }

  const handleOpen = () => {
    dispatch(switchEditableItem(undefined))
    dispatch(switchModal(true))
  }

  const handleOpenPositionMassive = (editMode: boolean) => {
    dispatch(switchModalPositionMassive(true))
    dispatch(setEditModePositionMassive(editMode))
  }

  const handleClose = () => {
    dispatch(switchModal(false))
  }

  const handleDoubleClick = (param: PositionGrid) => {
    dispatch(
      switchEditableItem({
        id: parseInt(param.id.toString()),
        warehouseId: param.warehouse.warehouseId!,
        subZone: param.subZone,
        positionCode: param.positionCode,
        positionDescription: param.positionDescription,
        positionName: param.positionName,
        active: param.active,
        subZoneId: param.subZoneId,
        typePositionId: param.typePositionId,
        zone: param.zone,
        zoneId: param.zoneId,
        externalStorage: param.externalStorage
      })
    )
    dispatch(switchModal(true))
  }

  const handleSubmitDelete = async () => {
    setLoadingConfirm(true)
    apiCall('DELETE', `${ApiConfig.PositionApi}/${idForDelete}`)
      .then((response) => {
        if (response.status !== 204) {
          throw new Error('Hubo un problema al eliminar el Posición.')
        }
      })
      .then(() => {
        MostrarMensajeConfirmacion(
          'Posición eliminada correctamente.',
          'success'
        )
        fetchFilteredData()
        dispatch(setIdForDelete(undefined))
      })
      .catch(({ data: { message } }) => {
        MostrarMensajeConfirmacion(message, 'error')
        dispatch(setIdForDelete(undefined))
      })
      .then(() => {
        handleCloseDelete()
        setLoadingConfirm(false)
      })
  }

  // MODAL DELETE
  const handleOpenDelete = (idForDelete: number | undefined) => {
    dispatch(setIdForDelete(idForDelete))
    dispatch(switchModalDelete(true))
  }

  const handleCloseDelete = () => {
    dispatch(switchModalDelete(false))
  }

  // MODAL VIEW
  const handleOpenView = (idForView: number | undefined) => {
    dispatch(setIdForDelete(idForView))
    dispatch(switchModalView(true))
  }
  const handleCloseView = () => {
    dispatch(setIdForDelete(undefined))
    dispatch(switchModalView(false))
  }

  // MODAL REDIRECCIÓN
  const hadleOpenRedireccion = () => {
    if (canRedirect) {
      dispatch(switchModalRedireccion(true))
    }
  }
  const handleCloseRedireccion = () => {
    dispatch(switchModalRedireccion(false))
  }

  const handleClosePositionMassive = (
    succes: boolean = false,
    message: string = ''
  ) => {
    dispatch(switchModalPositionMassive(false))
    if (message !== '') {
      if (succes) {
        MostrarMensajeConfirmacion(message, 'success')
      } else {
        MostrarMensajeConfirmacion(message, 'error')
      }
    }
  }

  const handleCloseExportPositionMassive = () => {
    dispatch(switchModalRedireccion(false))
  }

  // Si el mantenedor tiene hábilitada la redirección
  // mostramos el modal que consulta por redirección
  const handleRedireccionZona = () => {
    if (canRedirect) {
      dispatch(setRedirect(true))
    }
  }

  const handleChangeAutoCompleter = (e: any) => {
    setPosiciones([])
    if (e.target.value && e.target.value.length >= 3) {
      dispatch(setLoaderName(true))

      setTimeout(() => {
        apiCall(
          'GET',
          `${
            ApiConfig.PositionApi
          }/GetByCodeOrName?position=${encodeURIComponent(e.target.value)}`
        )
          .then((response) => {
            dispatch(setPosiciones(response.data))
          })
          .catch(({ data: { message } }) => {
            MostrarMensajeConfirmacion(message, 'error')
          })

        dispatch(setLoaderName(false))
      }, 500)
    }
  }

  const modifyActiveFieldPosition = async (element: PositionGrid) => {
    const modifiedActivePosition: PositionGrid = {
      ...element,
      active: !element.active,
      warehouseId: element.warehouse.warehouseId!
    }

    await handleSubmitEdit(modifiedActivePosition)
  }

  return {
    handleBusqueda,
    handleSubmit,
    handleSubmitEdit,
    fetchFilteredData,
    resetearBusqueda,
    handleSnackbar,
    handleOpen,
    handleClose,
    handleDoubleClick,
    handleSubmitDelete,
    handleOpenDelete,
    handleCloseDelete,
    handleOpenView,
    handleCloseView,
    hadleOpenRedireccion,
    handleCloseRedireccion,
    handleRedireccionZona,
    handleChangePage,
    handleChangeRowsPerPage,
    handleOnSortChanged,
    fetchDataGrid,
    modifyActiveFieldPosition,
    handleClosePositionMassive,
    handleCloseExportPositionMassive,
    handleOpenPositionMassive,
    fetchExportData
  }
}

export default positionBusiness
